import type { GetReportHistoryResponseType } from 'src/api/generated/touring/types';
import { mapReportHistoryEntryType } from './helpers';
import type { GetReportHistoryType } from './types';

export const mapGetReportHistoryResponseType = (
  api: GetReportHistoryResponseType
): GetReportHistoryType => ({
  results: api.data.map(mapReportHistoryEntryType),
});
